import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
  MenuItem,
  Box,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Select,
  Button,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import api from '../api/api';
import dayjs from 'dayjs';



const LogisticaDomicilioModal = ({
  open,
  onClose,
  selectedDomicilio,
  formData,
  setFormData,
  clientes,
  pacientesCliente,
  sucursales,
  esRecurrente,
  handleSave,
  razas, // si usas para paciente
}) => {

  const ESTADOS_TRANSPORTE = [
  'PENDIENTE', 'CONFIRMADO', 'EN_CAMINO_RECOGIDA', 'RECOGIDO',
  'EN_CLINICA', 'SERVICIO_COMPLETADO', 'EN_CAMINO_ENTREGA',
  'ENTREGADO', 'CANCELADO', 'NO_ASISTIO'
];

const [clienteSearch, setClienteSearch] = React.useState('');
const [clienteOptions, setClienteOptions] = React.useState([]);

React.useEffect(() => {
  const timer = setTimeout(async () => {
    if (clienteSearch.trim().length >= 2) {
      try {
        const res = await api.get(`/clientes/buscar?terminos_busqueda=${encodeURIComponent(clienteSearch)}`);
        setClienteOptions(res.data);
      } catch (err) {
        console.error('Error buscando clientes:', err);
      }
    } else {
      setClienteOptions([]);
    }
  }, 500);
  return () => clearTimeout(timer);
}, [clienteSearch]);

React.useEffect(() => {
  if (open && selectedDomicilio && selectedDomicilio.id_cliente) {
    // Si el cliente actual no está en la lista de opciones del Autocomplete, lo agregamos
    const existe = clienteOptions.some(c => c.id_cliente === selectedDomicilio.id_cliente);
    
    if (!existe) {
      setClienteOptions([{
        id_cliente: selectedDomicilio.id_cliente,
        // Ahora sí tomará el nombre que inyectamos en el paso anterior
        nombre_cliente: selectedDomicilio.nombre_cliente, 
        id_sucursal: selectedDomicilio.id_sucursal
      }]);
    }
  }
}, [open, selectedDomicilio]);



  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{selectedDomicilio ? 'Editar Domicilio' : 'Nuevo Domicilio'}</DialogTitle>
      <DialogContent>
        {/* Cliente */}
        <Autocomplete
          fullWidth
          options={clienteOptions}
          onInputChange={(e, newInputValue) => setClienteSearch(newInputValue)}
          // Cambia esto para manejar objetos nulos con seguridad
          getOptionLabel={(option) => typeof option === 'string' ? option : option.nombre_cliente || ""}
          value={clienteOptions.find(c => c.id_cliente === formData.id_cliente) || null}
          onChange={(e, newValue) => {
            setFormData({ 
              ...formData, 
              id_cliente: newValue?.id_cliente || '',
              id_sucursal: newValue?.id_sucursal || formData.id_sucursal,
              hoja_servicio: selectedDomicilio ? formData.hoja_servicio : (newValue?.hoja_servicio || '')
            });
          }}
          filterOptions={(x) => x}
          renderInput={(params) => (
            <TextField {...params} label="Cliente (escribe 2 letras...)" required sx={{ mt: 2 }} />
          )}
          noOptionsText={clienteSearch.length < 2 ? "Escribe 2 letras..." : "No encontrado"}
        />

        {/* Paciente */}
        <Autocomplete
  fullWidth
  options={pacientesCliente}
  // Buscamos el nombre de la raza en la lista de razas usando el id_raza del paciente
  getOptionLabel={(option) => {
    const nombre = option.nombre_paciente || 'Sin nombre';
    const razaDoc = razas?.find(r => r.id_raza === option.id_raza);
    const nombreRaza = option.nombre_raza || razaDoc?.nombre_raza || 'Raza desconocida';
    return `${nombre} — (${nombreRaza})`;
  }}
  value={pacientesCliente.find(p => p.id_paciente === formData.id_paciente) || null}
  onChange={(e, newValue) => setFormData({ ...formData, id_paciente: newValue?.id_paciente || null })}
  renderInput={(params) => (
    <TextField {...params} label="Paciente / Mascota" sx={{ mt: 2 }} />
  )}
  disabled={!formData.id_cliente}
/>

        {/* Sucursal */}
        <FormControl fullWidth sx={{ mt: 2 }} disabled={true}> {/* <--- Añade disabled aquí */}
          <InputLabel>Sucursal</InputLabel>
          <Select
            value={formData.id_sucursal}
            label="Sucursal"
            onChange={(e) => setFormData({ ...formData, id_sucursal: e.target.value })}
            readOnly // Opcional: añade esto para reforzar visualmente que es solo lectura
          >
            {sucursales.map(s => (
              <MenuItem key={s.id_sucursal} value={s.id_sucursal}>{s.nombre_sucursal}</MenuItem>
            ))}
          </Select>
          <Typography variant="caption" color="textSecondary" sx={{ ml: 1 }}>
            La sucursal se asigna automáticamente según el cliente seleccionado.
          </Typography>
        </FormControl>

        {/* Fecha y horas */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Fecha de servicio"
            value={dayjs(formData.fecha_servicio)}
            onChange={(newValue) => setFormData({ ...formData, fecha_servicio: newValue.format('YYYY-MM-DD') })}
            slotProps={{ textField: { fullWidth: true, sx: { mt: 2 } } }}
          />
        </LocalizationProvider>

        <TextField
          fullWidth
          label="Hora recogida aproximada"
          type="time"
          value={formData.hora_recogida_aprox || ''}
          onChange={(e) => setFormData({ ...formData, hora_recogida_aprox: e.target.value })}
          sx={{ mt: 2 }}
        />

        <TextField
          fullWidth
          label="Hora entrega aproximada"
          type="time"
          value={formData.hora_entrega_aprox || ''}
          onChange={(e) => setFormData({ ...formData, hora_entrega_aprox: e.target.value })}
          sx={{ mt: 2 }}
        />

        {/* Hoja de servicio con indicador recurrente */}
        <Box sx={{ mt: 3, p: 2, bgcolor: esRecurrente ? '#e8f5e9' : '#fff3e0', borderRadius: 2, border: '1px solid', borderColor: esRecurrente ? 'success.main' : 'warning.main' }}>
          <TextField
            fullWidth
            multiline
            rows={5}
            label={esRecurrente ? "Hoja de servicio (precargada)" : "Hoja de servicio (obligatorio)"}
            value={formData.hoja_servicio || ''}
            onChange={(e) => setFormData({ ...formData, hoja_servicio: e.target.value })}
            required={!esRecurrente}
            error={!esRecurrente && !formData.hoja_servicio?.trim()}
            helperText={
              esRecurrente
                ? 'Precargado de recurrente (puedes editar)'
                : !formData.hoja_servicio?.trim()
                  ? '¡Obligatorio! Describe el servicio'
                  : 'Ej: Baño + vacunas'
            }
            placeholder="Describe el servicio solicitado"
          />
          {esRecurrente && <Chip label="Cliente recurrente" color="success" size="small" sx={{ mt: 1 }} />}
          {!esRecurrente && <Chip label="Cliente no recurrente" color="warning" size="small" sx={{ mt: 1 }} />}
        </Box>

        {/* Otros campos: servicio_realizado, modificaciones, etiquetas, notas, etc. */}
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Servicio realizado"
          value={formData.servicio_realizado || ''}
          onChange={(e) => setFormData({ ...formData, servicio_realizado: e.target.value })}
          sx={{ mt: 2 }}
        />

        <TextField
          fullWidth
          label="Modificaciones"
          value={formData.modificaciones || ''}
          onChange={(e) => setFormData({ ...formData, modificaciones: e.target.value })}
          sx={{ mt: 2 }}
        />

        <TextField
          fullWidth
          label="Etiquetas (separadas por coma)"
          value={formData.etiquetas || ''}
          onChange={(e) => setFormData({ ...formData, etiquetas: e.target.value })}
          sx={{ mt: 2 }}
        />

        {/* Estados */}
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Estado Transporte</InputLabel>
          <Select
            value={formData.estado_transporte}
            label="Estado Transporte"
            onChange={(e) => setFormData({ ...formData, estado_transporte: e.target.value })}
          >
            {ESTADOS_TRANSPORTE.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}
          </Select>
        </FormControl>

        {/* Notas */}
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Notas cliente"
          value={formData.notas_cliente || ''}
          onChange={(e) => setFormData({ ...formData, notas_cliente: e.target.value })}
          sx={{ mt: 2 }}
        />

        {/* Notas Conductor */}
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Notas para el Conductor"
          placeholder="Ej: El perro es nervioso, llevar bozal..."
          value={formData.notas_conductor || ''}
          onChange={(e) => setFormData({ ...formData, notas_conductor: e.target.value })}
          sx={{ mt: 2 }}
        />

        {/* Notas Clínica */}
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Notas para la Clínica"
          placeholder="Ej: Entregar directamente al Dr. Pérez..."
          value={formData.notas_clinica || ''}
          onChange={(e) => setFormData({ ...formData, notas_clinica: e.target.value })}
          sx={{ mt: 2 }}
        />

        {/* Factura */}
        <TextField
          fullWidth
          label="Número de factura"
          value={formData.numero_factura || ''}
          onChange={(e) => setFormData({ ...formData, numero_factura: e.target.value })}
          sx={{ mt: 2 }}
        />

        {/* Fecha de Factura */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Fecha de factura"
            value={formData.fecha_factura ? dayjs(formData.fecha_factura) : null}
            onChange={(newValue) => 
              setFormData({ 
                ...formData, 
                fecha_factura: newValue ? newValue.format('YYYY-MM-DD') : null 
              })
            }
            slotProps={{ 
              textField: { 
                fullWidth: true, 
                sx: { mt: 2 },
                helperText: "Opcional: Fecha de emisión de la factura"
              } 
            }}
          />
        </LocalizationProvider>

        {/* ... agrega notas_conductor y notas_clinica de forma similar */}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSave} variant="contained">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogisticaDomicilioModal;